import { render, staticRenderFns } from "./ListDocFaq.vue?vue&type=template&id=e93cd350&"
import script from "./ListDocFaq.vue?vue&type=script&lang=js&"
export * from "./ListDocFaq.vue?vue&type=script&lang=js&"
import style0 from "./ListDocFaq.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports